import React from 'react';
import { Text, TextProps, StyleSheet } from 'react-native';
import { colors, fonts, spacing } from '../theme';

export function Heading({ style, ...rest }: TextProps) {
  return <Text style={[styles.heading, style]} {...rest} />;
}

export function Subtitle({ style, ...rest }: TextProps) {
  return <Text style={[styles.subtitle, style]} {...rest} />;
}

const styles = StyleSheet.create({
  heading: {
    fontFamily: fonts.display,
    fontSize: 26,
    color: colors.ink,
    textAlign: 'center',
    marginBottom: spacing.sm,
  },
  subtitle: {
    fontFamily: fonts.body,
    fontSize: 15,
    color: colors.inkSoft,
    textAlign: 'center',
    marginBottom: spacing.lg,
  },
});
